/** @format */
import { iccidMvnoStatusI18n, iccidMvnoStatusIdInt } from '../views/lib/search/IccidMvnoStatusHelper';
import { iccidStateI18n } from '../views/Storage/imsi/IccidState';

export const iccidStatus = (status) => {
    if (status >= 100) {
        return 'pools:state.change_in_progress';
    }
    switch (status) {
        case 0:
            return iccidStateI18n.FREE;
        case 1:
            return iccidStateI18n.USED;
        case 2:
            return iccidStateI18n.PLANNED;
        case 3:
            return iccidStateI18n.LOCK;
        case 4:
            return iccidStateI18n.ARCHIVE;
        default:
            return 'pools:state.not_defined';
    }
};

export const PlkStatusMap = {
    ACTIVE: iccidMvnoStatusIdInt.ACTIVE,
    CANCELLED: iccidMvnoStatusIdInt.CANCELLED,
    PREACTIVATED: iccidMvnoStatusIdInt.PREACTIVATED,
    RESTRICTED: iccidMvnoStatusIdInt.RESTRICTED,
    RESTRICTED2: iccidMvnoStatusIdInt.RESTRICTED2,
    BLOCK_50: iccidMvnoStatusIdInt.BLOCK_50,
    BLOCK_98: iccidMvnoStatusIdInt.BLOCK_98,
    BLOCK_99: iccidMvnoStatusIdInt.BLOCK_99,
    ZERO_CREDIT: iccidMvnoStatusIdInt.ZERO_CREDIT,
    FAKE_CHANGE_PRODUCT: iccidMvnoStatusIdInt.FAKE_CHANGE_PRODUCT,
};

export const iccidType = {
    E: 'E',
    Q: 'Q',
    ESIM: 'ESIM',
};

export const releaseESIMLocal = 6;
export const releaseESIMRemote = 5;

export const iccidState = {
    FREE: 0,
    USED: 1,
    RESERVATION: 2,
    ARCHIVE: 4,
};

export const iccidOperatorStatus = (status) => {
    if (status !== iccidMvnoStatusIdInt.FAKE_CHANGE_PRODUCT && (status >= 100 || status === null)) {
        return 'pools:state.not_synchronized';
    }
    switch (status) {
        case PlkStatusMap.PREACTIVATED:
            return iccidMvnoStatusI18n.PREACTIVATED;
        case PlkStatusMap.ACTIVE:
            return iccidMvnoStatusI18n.ACTIVE;
        case PlkStatusMap.ZERO_CREDIT:
            return iccidMvnoStatusI18n.ZERO_CREDIT;
        case PlkStatusMap.RESTRICTED:
            return iccidMvnoStatusI18n.RESTRICTED;
        case PlkStatusMap.RESTRICTED2:
            return iccidMvnoStatusI18n.RESTRICTED2;
        //case 6:
        //    return "pools:state.quarantine";
        case PlkStatusMap.CANCELLED:
            return iccidMvnoStatusI18n.CANCELLED;
        //case 9:
        //    return "pools:state.pre_expired";
        //case 10:
        //    return "pools:state.susspended";
        //case 50:
        //    return "pools:state.block_50";
        //case 55:
        //    return "pools:state.block_55";
        case PlkStatusMap.BLOCK_98:
            return iccidMvnoStatusI18n.BLOCK_98;
        case PlkStatusMap.BLOCK_99:
            return iccidMvnoStatusI18n.BLOCK_99;
        case PlkStatusMap.FAKE_CHANGE_PRODUCT:
            return iccidMvnoStatusI18n.FAKE_CHANGE_PRODUCT;
        default:
            return 'pools:state.not_defined';
    }
};
